// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {StudentAttendanceReportBase, StudentAttendanceReportPayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchStudentAttendanceReport(
  payload: StudentAttendanceReportPayload
): Promise<APIResponse<StudentAttendanceReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.studentAttendanceReport, payload)
  return response.data
}
